import type { TimedMusicXmlNote } from "./songEngine";

/**
 * Avanza el índice de aprendizaje saltando silencios de forma síncrona.
 * No usar setState dentro de un `while` — React no actualiza refs hasta el siguiente render.
 *
 * @returns Índice final, o `-1` si no quedan eventos.
 */
export function skipLearnRestsSync(
  notes: TimedMusicXmlNote[],
  startIndex: number,
  maxSteps = notes.length + 2
): number {
  let idx = Math.max(0, Math.min(startIndex, notes.length - 1));
  let steps = 0;

  while (steps++ < maxSteps) {
    const cn = notes[idx];
    if (!cn?.isRest) return idx;

    const startTime = cn.startTime;
    const next = notes.findIndex((n, i) => i > idx && n.startTime !== startTime);
    if (next < 0) return -1;
    if (next === idx) return idx;
    idx = next;
  }

  return idx;
}
